import React from 'react'

function CubesIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}>
      <defs>
        <clipPath id="clip-path">
          <path fill="none" stroke="#707070" strokeWidth="1" d="M0 0H32V32H0z" data-name="Rectangle 8999"></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)" data-name="Mask Group 444">
        <g data-name="Group 56686" transform="translate(7.447 3.515)">
          <path fill="#fff" d="M0 0H11V10H0z" data-name="Rectangle 8995"></path>
          <path fill="#d3dade" d="M0 0H11V11H0z" data-name="Rectangle 8996" transform="translate(10)"></path>
          <path fill="#fff" d="M0 0H11V11H0z" data-name="Rectangle 8997" transform="translate(14 14)"></path>
          <path fill="#fff" d="M0 0H11V11H0z" data-name="Rectangle 8998" transform="translate(0 14)"></path>
        </g>
        <g fill="#263238" data-name="Group 56687" transform="translate(2.447 2.447)">
          <path
            d="M1.446 1.349v9.613a.35.35 0 00.361.337h9.4v-9.95H1.446M0 0h12.65v12.649H1.807A1.75 1.75 0 010 10.963z"
            data-name="Rectangle 7787"
            transform="rotate(180 13.553 6.325)"
          ></path>
          <path
            d="M1.557 1.446V11.2H10.7a.377.377 0 00.389-.361v-9.4H1.557M0 0h12.65v10.843a1.88 1.88 0 01-1.95 1.807H0z"
            data-name="Rectangle 7788"
            transform="translate(14.456 14.457)"
          ></path>
          <path
            d="M1.946 1.557a.39.39 0 00-.389.389v9.147h9.536V1.557H1.946m0-1.557h10.7v12.65H0V1.946A1.946 1.946 0 011.946 0z"
            data-name="Rectangle 7786"
          ></path>
          <path
            d="M1.557 1.446V11.2h9.536V1.8a.377.377 0 00-.389-.361H1.557M0 0h10.7a1.88 1.88 0 011.95 1.807V12.65H0z"
            data-name="Rectangle 7789"
            transform="rotate(180 6.325 13.553)"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default CubesIcon
